<div class="mapping-lun-link"
     (click)="onClick(data,$event)"
     (mouseleave)="mouseLeave()"
     nTooltipTrigger="none"
     [nTooltip]="lunTips"
     [nTooltipVisible]="toolTipVisible"
     nTooltipPlacement="top">
    {{data[name]}}
</div>
